import React from "react";
import Joi from "joi-browser";
import authBackground from "../assets/images/auth-bg.png";
import Form from "../components/authForm";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { loginAdminAsync } from "../redux/users/users.action";
import WithSpinner from "../components/withSpinner";
import { selectLoadingStatus } from "./../redux/users/users.selector";
import { ToastContainer } from "react-toastify";
import Logo from "../assets/images/logo_test.png";

import "../stylesheets/style.css";
import "../stylesheets/app.css";
import "../stylesheets/dashboard.css";
import "../stylesheets/admin.css";

class Login extends Form {
  state = {
    data: {
      email: "",
      password: "",
    },
    isLoading: false,
    error: {},
  };

  schema = {
    email: Joi.string().email().required().label("Email"),
    password: Joi.string().min(8).max(20).required().label("Password"),
  };

  doSubmit = async () => {
    const { loginAdminAsync } = this.props;
    loginAdminAsync(this.state.data);
    this.setState({
      data: {
        email: "",
        password: "",
      },
    });
  };

  componentDidMount() {
    document.title = "African Movies | Admin Login";
  }

  render() {
    const { isLoading } = this.props;
    return isLoading ? (
      <WithSpinner />
    ) : (
      <React.Fragment>
        <section className="auth">
          <div className="row auth-row no-gutter">
            <div
              className="col-md-6 bg-light-black"
              style={{ backgroundColor: "#300E34" }}
            >
              <div className="container  d-flex h-100">
                <span className="m-auto">
                  <div className="text-center mb-5">
                    <a href="index.html">
                      <img src={Logo} height={65} width={240} />
                    </a>
                    <h2 className="mt-3" style={{ color: "#fff" }}>
                      {" "}
                      Admin Login
                    </h2>
                    <p style={{ marginRight: "20px", marginLeft: "20px" }}>
                      Login To Access Your Dashboard{"   "}
                    </p>
                  </div>

                  <form onSubmit={this.handleSubmit}>
                    {this.renderInput(
                      "text",
                      "email",
                      "Email",
                      "Email",
                      "fa fa-envelope",
                    )}
                    {this.renderInput(
                      "password",
                      "password",
                      "Password",
                      "Password",
                      "fa fa-key",
                    )}
                    <br />

                    {this.renderButton("Login")}

                    <hr className="mt-4" />
                  </form>
                </span>
              </div>
            </div>

            <div
              className="col-md-6 p-0 auth-row1 d-none d-md-block"
              style={{ backgroundImage: `url(${authBackground})` }}
            >
              <div className="overlay"></div>
              <h4
                className="auth-row1-text text-center"
                style={{ color: "#300E34" }}
              >
                Unlimited african movies,
                <br />
                TV shows, and more...
              </h4>
            </div>
          </div>
        </section>
        <ToastContainer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isLoading: selectLoadingStatus,
});

const mapDispatchToProps = (dispatch) => ({
  loginAdminAsync: (user) => dispatch(loginAdminAsync(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
